/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
const user = (id: string): string => {
    return '/snmp/users/' + id;
};

const settings: string = '/snmp';

const users: string = '/snmp/users';

export const SNMPEnum = {
    GET_SNMP_SETTINGS: settings,
    PUT_SNMP_SETTINGS: settings,
    GET_SNMP_USERS: users,
    POST_SNMP_USER: users,
    PUT_SNMP_USER: user,
    DELETE_SNMP_USER: user
};
